import React from "react";

export const ExternalLink = ({ children })  => {
  console.log(children)
    return (
      <a
        className="fancy-undeline"
        href={children}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
}
